import _ from "lodash";
import React, { createRef } from "react";
import classes from "./LoginPage.scss";
import {
  colors,
  fontStyle,
  TERM_OF_SERVICE_URL,
  TERM_OF_USE_URL,
  PRIVACY_URL,
  getCloudUrl,
  COOKIE_URL,
  LEX,
  LEX_PILOT,
  GOOGLE_CLIENT_ID,
} from "Constants";
import { ToddleIcon, LogoTextSvg, ChevronIcon } from "SvgComponents";
import {
  WarningTriangleFilled,
  LeftArrowCircleOutlined,
  LexColored,
  CleverColored,
  SquareFilled,
  MailColored,
  ChevronLeftOutlined,
} from "@toddle-edu/ds-icons";
import { Button, DropdownMenu } from "@toddle-edu/ds-web";
import {
  getCountString,
  isIphone,
  onEnterOrSpaceKeyDown,
  setUTMSourceInStorage,
} from "Utils";
import { connect } from "react-redux";
import { recordEvent, recordTrait } from "lib/eventTracker";
import { initMixPanel } from "lib/eventTracker";
import cx from "classnames";
import { validateEmail } from "@toddle-edu/common-utils";

import {
  getIdpUrlFromServer,
  authenticateUserWithServer,
  updateCurrentScreen,
  sendForgotPassword,
  sendResetPassword,
  verifyDomain,
  createUnauthenticatedUser,
  createSchoolRequest,
  generateOTPForUnauthenticatedUser,
  generateOTPForParent,
  updateInputField,
  verifyUnauthenticatedUserOTP,
  verifyParentOTP,
  createPYPCoordinator,
  createInvitedUser,
  createInvitedParent,
  setCurrentScreen,
  getDesignationList,
  openChat,
  setToastMsg,
  signInUsingCode,
  setBifurcationAction,
  setRedirectUrl,
  setUserComingFromPublicAccess,
  setCurrentParentLoginTab,
  handleCreateParentAccount,
  handleVerifyParentInviteCode,
  updateInvitedFamilyData,
  generateOtpForSignIn,
  verifyParentOTPForSignIn,
  setParentInviteCode,
  generateEmailOTPForSignIn,
  getIsNewLoginFlowEnabled,
  getIsSamlLoginEnabled,
  getIsPwdDisabledInParentSignup,
  getLoginConfig,
  getOrgWorkSpaceDetails,
  getSamlBackendRedirectUrl,
  resetOrgWorkSpaceDetails,
  loginWithRedirectUrl,
  setAuthRegion,
  getIsPasswordloginEnabled,
  getIsLoginFlowEnabledV2,
} from "Login/modules/LoginModule";
import LoginForm from "./LoginForm";
import LoginFormV2 from "./LoginFormV2";
import LoginFormV3 from "./LoginFormV3";
import VisitorSignUp from "./VisitorSignUp";
import ParentLoginForm from "./ParentLoginForm";
import ForgotPassword from "./ForgotPassword";
import ForgotPhonePassword from "./ForgotPhonePassword";
import LoginWithPhoneOTP from "./LoginWithPhoneOTP";
import ResetPassword from "./ResetPassword";
import LoginHome from "./LoginHome";
import StudentLogin from "./StudentLogin";
import TeacherLogin from "./TeacherLogin";
import ParentLogin from "./ParentLogin";
import CreateParentAccount from "./CreateParentAccount";
import OrganizationSelection from "./OrganizationSelection";
import CreateAccount from "./CreateAccount";
import AddSchool from "./AddSchool";
import VerifyOTP from "./VerifyOTP";
import VerifyPhoneOTP from "./VerifyPhoneOTP";
import AddPYPDetails from "./AddPYPDetails";
import RequestSuccess from "./RequestSuccess";
import AddIdentification from "./AddIdentification";
import VisitorLogin from "./VisitorLogin";
import SchoolCodeForm from "./SchoolCodeForm";
import updateQueryParameters, {
  goToBack,
  goToRootPath,
  navigateToOrgWorkspaceLoginPage,
} from "modules/NavigationModule";
import MagicLinkExpired from "AppComponents/MagicLinkExpired";
import ThirdPartyAuth from "AppComponents/ThirdPartyAuth";
import VerifyParentInviteCode from "./VerifyParentInviteCode";
import SamlLogin from "./SamlLogin";
import { getIsChina, enableOrgWorkspaceLoginFlow } from "config";
import { getJsonItem, setJsonItem } from "services/localStorage";
import {
  LEX_CODE_VERIFIER_KEY,
  LEX_PILOT_CODE_VERIFIER_KEY,
  IS_TODDLE_INITIATED,
} from "Constants/stringConstants";
import classNames from "classnames";
import CustomLoginButton from "UIComponents/CustomLoginButton";
import GoogleLoginBtn from "UIComponents/GoogleLoginBtn";
import GridLayoutWrapper from "UIComponents/GridLayoutWrapper";
import MicrosoftLoginBtn from "UIComponents/MicrosoftLoginBtn";
import { isInKioskMode } from "Utils/DeviceDetectHelpers";
import { openLinkInNewTab } from "modules/Services";
import VerificationAuthModal from "routes/components/MultiFactorAuthentication/components/VerificationAuthModal";

const customStyle = {
  containerStyle: {
    paddingTop: "84px",
    paddingBottom: "32px",
  },
  headerStyle: {
    fontSize: "32px",
    lineHeight: "44px",
    color: colors.textDefault,
    ...fontStyle.bold,
  },

  headerStyleV2: {
    fontSize: "24px",
    lineHeight: "32px",
    color: colors.textDefault,
    ...fontStyle.bold,
  },

  subTextStyle: {
    fontSize: "16px",
    lineHeight: "24px",
    color: colors.textSubtle,
    ...fontStyle.medium,
  },
};

const styles = {
  innerConStyle: {
    width: "auto",
  },
  containerStyle: {
    height: "48px",
    marginBottom: "0px",
  },
};

const inputStyle = {
  labelContainerStyle: {
    marginBottom: "8px",
  },
  labelStyle: {
    fontSize: "1.6rem",
    color: colors.neutral300,
    ...fontStyle.demiBold,
    lineHeight: "1.6rem",
  },
  inputStyle: {
    padding: "12px 16px",
    borderRadius: "8px",
  },
  errorStyle: {
    borderColor: colors.salmon60,
    backgroundColor: colors.white,
  },
};

const LOGIN_OPTION_TYPES = {
  IDP_CONFIG: "IDP_CONFIG",
  OAUTH_IDP_CRED: "OAUTH_IDP_CRED",
  SSO: "SSO",
  OAUTH_SP_CRED: "OAUTH_SP_CRED",
  EMAIL_OTP_LOGIN: "EMAIL_OTP_LOGIN",
  PASSWORD_LOGIN: "PASSWORD_LOGIN",
  STUDENT_SIGNIN_CODE: "STUDENT_SIGNIN_CODE",
  SMS_OTP_LOGIN: "SMS_OTP_LOGIN",
  CREATE_PARENT_ACCOUNT: "CREATE_PARENT_ACCOUNT",
};

const consoleError = console.error;
class LoginPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.backButtonRef = createRef();
  }

  state = {
    showMagicLinkModal: true,
    loginButtonsCount: 0,
  };

  componentDidMount = () => {
    const {
      currentScreen,
      location,
      setBifurcationAction,
      setRedirectUrl,
      setUserComingFromPublicAccess,
      userType,
      orgWorkspaceDetails,
      navigateToOrgWorkspaceLoginPage,
      enableOrgWorkspaceLoginFlow,
      isOrgWorkspaceLoginPage,
      isLoading,
      loginWithRedirectUrl,
    } = this.props;
    this.trackCurrentScreenPage({ currentScreen });
    setUTMSourceInStorage();
    // this.target = _.get(
    //   this.props,
    //   "location.query.utm_source",
    //   "direct_landing"
    // );

    // * Handling redirected url from _self window login for kiosk mode
    if (_.get(window, "location.hash")) {
      const queryString = _.trimStart(_.get(window, "location.hash"), "#");
      const urlParams = new URLSearchParams(queryString);
      const stateParams = urlParams.get("state");
      if (stateParams) {
        const state = new URLSearchParams(stateParams);
        if (state.get("mode") === "kiosk") {
          const error = urlParams.get("error");
          const accessToken = urlParams.get("access_token");
          loginWithRedirectUrl(state, accessToken, error);
          return;
        }
      }
    }

    const pathname = _.get(location, "pathname", "/");

    const bifurcationAction = _.get(location, "query.action");
    if (bifurcationAction) setBifurcationAction(bifurcationAction);

    const redirectUrl = _.get(location, "query.redirect_url");
    if (redirectUrl) {
      setRedirectUrl(redirectUrl);
    }

    const isUserComingFromPublicAccess = _.get(
      location,
      "query.is_public_access"
    );
    if (isUserComingFromPublicAccess)
      setUserComingFromPublicAccess(isUserComingFromPublicAccess);

    //const type = _.get(window, "location.query.type", ""); this gives the stale value i.e. original not the updated one
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get("type") || "";

    if (!type && pathname == "/") {
      this.updateCurrentScreen({ type: "loginHome" });
    }

    if (type === "studentLogin" && userType !== "student") {
      this.updateCurrentScreen({ type: "studentLogin", userType: "student" });
    }

    const queryData = _.get(location, "query", {});

    const screen = _.get(queryData, "screen", "");

    if (screen === "visitorSignup") {
      const {
        email,
        user_id: id,
        token,
        first_name,
        last_name,
        identity_id,
        region,
        moduleName,
        invitedBy,
        orgName,
        visitorsOrganizationName,
        contact,
      } = queryData;
      const visitorName = `${first_name} ${last_name}`;

      this.updateCurrentScreen({ type: screen });
      this.props.updateInputField(screen, {
        email,
        id,
        token,
        name: visitorName,
        identityId: identity_id,
        region,
        firstName: first_name,
        lastName: last_name,
        moduleName,
        invitedBy,
        orgName,
        visitorsOrganizationName,
        contact,
      });
    }

    /**
     * go to orgWorkspace login-page if school code is found and there are no query params
     *  - if query params are there, then we will handle it on default login-page of Toddle with `handleQueryParameters` in `LoginView`
     */
    if (
      _.isEmpty(queryData) &&
      enableOrgWorkspaceLoginFlow &&
      !isOrgWorkspaceLoginPage &&
      !_.isEmpty(_.get(orgWorkspaceDetails, "schoolCode")) &&
      !isLoading // to avoid redirection to orgWorkspace login-page while reloading and switching org
    ) {
      navigateToOrgWorkspaceLoginPage({
        schoolcode: orgWorkspaceDetails.schoolCode,
        userType,
      });
    }
  };

  updateInputField = (data, screen) => {
    const { updateInputField, currentScreen } = this.props;
    updateInputField(screen || currentScreen, data);
  };

  fetchLoginData = () => {
    const {
      userType,
      enableLoginFlowV2,
      formData: {
        teacherLogin,
        parentLogin,
        visitorLogin,
        loginFormV2,
        loginFormV3,
      },
      role,
    } = this.props;

    if (enableLoginFlowV2) {
      return loginFormV3;
    }

    switch (userType) {
      case "staff":
        if (role === "visitor") {
          return visitorLogin;
        }
        return teacherLogin;
      case "parent":
        return parentLogin;
      case "student":
        return loginFormV2;
    }
  };

  trackCurrentScreenPage = ({ currentScreen }) => {
    switch (currentScreen) {
      case "loginHome":
      case "teacherLogin":
        // EventTracker.recordEvent({
        //   eventName: "Viewed Page",
        //   eventData: { page: "login", user_type: "lead" }
        // });
        // EventTracker.recordTrait({ data: { user_type: "lead" } });
        break;
      case "organizationSelection":
        initMixPanel();
        recordEvent({
          eventName: "Viewed Page",
          eventData: {
            page: "create account",
            user_type: "lead",
            // target: this.target
          },
        });
        recordTrait({ data: { user_type: "lead" } });
        break;
      case "addSchool":
        initMixPanel();
        recordEvent({
          eventName: "Viewed Page",
          eventData: {
            page: "add school",
            user_type: "lead",
            // target: this.target
          },
        });

        break;
      case "createAccount":
        initMixPanel();
        recordEvent({
          eventName: "Viewed Page",
          eventData: {
            page: "ask user details",
            user_type: "lead",
            // target: this.target
          },
        });
        break;
      case "addIdentification":
        recordEvent({
          eventName: "Viewed Page",
          eventData: {
            page: "ask user identification",
            user_type: "lead",
            // target: this.target
          },
        });
        break;
    }
  };

  onNextClick = () => {
    const {
      currentScreen,
      designationList,
      formData: {
        loginForm = {},
        loginFormV2 = {},
        forgotPassword = {},
        resetPassword = {},
        organizationSelection = {},
        createAccount = {},
        addSchool = {},
        verifyOTP = {},
        addPYPDetails = {},
        requestSuccess = {},
        addIdentification = {},
      } = {},
    } = this.props;
    const { selectedSchool } = organizationSelection;
    let designation, email, role, org_name, firstName, lastName;

    switch (currentScreen) {
      case "organizationSelection":
        org_name = selectedSchool?.name;
        recordTrait({ data: { user_type: "lead", org_name } });
        break;
      case "addSchool": {
        const { type } = addSchool;
        firstName = addSchool.firstName;
        lastName = addSchool.lastName;
        org_name = addSchool.name;
        designation = addSchool.designation;
        email = addSchool.email;
        role = _.get(_.find(designationList, { value: designation }), "label");
        // EventTracker.identifyUser({ identityString: email });
        recordTrait({
          data: {
            user_type: "lead",
            fname: firstName,
            lname: lastName,
            email,
            role,
            org_name,
          },
        });
        recordEvent({
          eventName: "Provided School Info",
          eventData: {
            org_type: type,
            fname: firstName,
            lname: lastName,
            email,
            role,
            org_name,
            user_type: "lead",
            // target: this.target
          },
        });

        break;
      }
      case "createAccount": {
        const { stateCode } = createAccount;
        firstName = createAccount.firstName;
        lastName = createAccount.lastName;

        const is_work_email = !(
          stateCode == "SUP_DOM_MIS_MTCH_NO_ORG" ||
          stateCode == "SUP_DOM_MIS_MTCH_HS_ORG"
        );

        org_name = selectedSchool.name;
        designation = createAccount.designation;
        email = createAccount.email;
        role = _.get(_.find(designationList, { value: designation }), "label");
        // EventTracker.identifyUser({ identityString: email });
        recordTrait({
          data: {
            user_type: "lead",
            fname: firstName,
            lname: lastName,
            email,
            role,
            org_name,
          },
        });

        recordEvent({
          eventName: "Provided Signup Details",
          eventData: {
            role,
            is_work_email,
            email,
            org_name,
            fname: firstName,
            lname: lastName,
            user_type: "lead",
            // target: this.target
          },
        });

        break;
      }
    }
  };

  resetScreen = (screenName, data = {}) => {
    const { updateInputField } = this.props;
    updateInputField(screenName, data);
  };

  updateCurrentScreen = ({
    type,
    userType: localUserType,
    paramsToBeRemoved,
    role,
  }) => {
    const { updateCurrentScreen, updateQueryParameters, userType } = this.props;

    updateCurrentScreen({
      type,
      usertype: localUserType || userType,
      paramsToBeRemoved,
      role,
    });
  };

  checkEmailVerification = value => {
    const isValidEmail = !!value && validateEmail(value);
    if (!isValidEmail) {
      return "Please enter a valid email address";
    } else {
      return "";
    }
  };

  renderErrorComponent = error => {
    // return <div className={classes.errorText}>{error}</div>;

    const errorContainerClasses = cx("text-error50 text-body-3 mt-1 flex", {
      invisible: !error,
    });
    return (
      <span className={errorContainerClasses}>
        <span className="mr-1 flex justify-center">
          <WarningTriangleFilled variant="critical" size="xxx-small" />
        </span>
        <span className="break-all pt-0.5">{error}</span>
      </span>
    );
  };

  onGoogleSignInCallBack = data => {
    const { userType, currentScreen, workspaceOrgId } = this.props;
    const idToken = data.access_token;

    // Login only when current screen is correct according user type
    // if (
    //   !!idToken &&
    //   ((currentScreen == "teacherLogin" && userType == "staff") ||
    //     (currentScreen == "studentLogin" && userType == "student"))
    // ) {
    this.props.authenticateUserWithServer({
      idToken,
      method: "googleV2",
      userType,
      orgId: workspaceOrgId,
    });
    // }
  };

  onMicroSoftSignInCallBack = accessToken => {
    // Comment it as of now
    const { userType, currentScreen, workspaceOrgId } = this.props;
    // Login only when current screen is correct according user type
    // if (
    //   accessToken &&
    //   ((currentScreen == "teacherLogin" && userType == "staff") ||
    //     (currentScreen == "studentLogin" && userType == "student"))
    // ) {
    this.props.authenticateUserWithServer({
      idToken: accessToken,
      method: "microsoft",
      userType,
      orgId: workspaceOrgId,
    });
    // }
  };

  //clever log in callback
  onCleverSignInCallBack = ({ accessCode, redirectUri }) => {
    const { userType, workspaceOrgId } = this.props;

    this.props.authenticateUserWithServer({
      idToken: accessCode,
      method: "clever",
      userType,
      redirectUri,
      orgId: workspaceOrgId,
    });
  };

  onLexSignInCallBack = ({ accessCode, redirectUri }) => {
    const { userType, workspaceOrgId } = this.props;
    const codeVerifier = getJsonItem(LEX_CODE_VERIFIER_KEY);

    this.props.authenticateUserWithServer({
      idToken: accessCode,
      method: "lex",
      userType,
      redirectUri,
      codeVerifier,
      orgId: workspaceOrgId,
    });
  };

  onLexPilotSignInCallBack = ({ accessCode, redirectUri }) => {
    const { userType, authenticateUserWithServer, workspaceOrgId } = this.props;
    const codeVerifier = getJsonItem(LEX_PILOT_CODE_VERIFIER_KEY);

    authenticateUserWithServer({
      idToken: accessCode,
      method: "pilot-lex",
      userType,
      redirectUri,
      codeVerifier,
      orgId: workspaceOrgId,
    });
  };

  onSignInClick = () => {
    const { userType, workspaceOrgId } = this.props;

    this.props.authenticateUserWithServer({
      method: "local",
      userType: userType,
      orgId: workspaceOrgId,
    });
  };

  onSamlSignInClick = () => {
    const {
      userType,
      formData: { samlLoginForm = {} } = {},
      getIdpUrlFromServer,
    } = this.props;

    getIdpUrlFromServer({
      userType,
      schoolCode: samlLoginForm.schoolcode,
    });
  };

  onSignInWithOTPClick = () => {
    const { userType, workspaceOrgId } = this.props;

    this.props.authenticateUserWithServer({
      method: "local",
      userType: userType,
      isEmailOTPSignIn: true,
      orgId: workspaceOrgId,
    });
  };
  onPhoneSignInClick = () => {
    const { userType } = this.props;

    this.props.authenticateUserWithServer({
      method: "local",
      userType,
      isPhoneSignIn: true,
    });
  };

  onGoToSchoolWorkspaceClick = () => {
    const {
      userType,
      formData: { schoolCodeForm: { schoolcode } = {} } = {},
      navigateToOrgWorkspaceLoginPage,
      getLoginConfig,
    } = this.props;

    getLoginConfig({
      schoolCode: schoolcode,
      successCallback: () => {
        navigateToOrgWorkspaceLoginPage({
          schoolcode: _.toLower(schoolcode),
          userType,
          skipMobileRedirect: true,
        });
      },
    });
  };

  updateCleverAuthRef = ref => {
    this.authCleverRef = _.get(ref, "refs.wrappedInstance", {});
  };

  updateLexAuthRef = ref => {
    this.authLexRef = _.get(ref, "refs.wrappedInstance", {});
  };

  updateLexPilotAuthRef = ref => {
    this.authLexPilotRef = _.get(ref, "refs.wrappedInstance", {});
  };

  updateToddleInitiatedValue = value => {
    setJsonItem({
      key: IS_TODDLE_INITIATED,
      value,
    });
  };

  onCleverLogInClick = () => {
    if (this.authCleverRef) {
      this.updateToddleInitiatedValue(true);
      this.authCleverRef.onAuthClick();
    }
  };

  onLexLoginClick = () => {
    if (this.authLexRef) {
      this.updateToddleInitiatedValue(true);
      this.authLexRef.onAuthClick();
    }
  };

  onLexPilotLoginClick = () => {
    if (this.authLexPilotRef) {
      this.updateToddleInitiatedValue(true);
      this.authLexPilotRef.onAuthClick();
    }
  };

  getLexOptions = () => {
    return [
      {
        key: LEX_PILOT,
        label: "Lex (Global)",
        icon: <LexColored size="xx-small" />,
      },
      {
        key: LEX,
        label: "Lex (Brazil)",
        icon: <LexColored size="xx-small" />,
      },
    ];
  };

  onClickLexOption = ({ key }) => {
    if (key === LEX_PILOT) {
      this.onLexPilotLoginClick();
    } else if (key === LEX) {
      this.onLexLoginClick();
    }
  };

  onLoginClick = () => {
    const {
      updateCurrentScreen,
      enableNewLoginFlow,
      enableLoginFlowV2,
    } = this.props;

    updateCurrentScreen({
      type: enableLoginFlowV2
        ? "loginFormV3"
        : enableNewLoginFlow
        ? "loginFormV2"
        : "loginForm",
    });
  };

  onOauthIdpSignInClick = loginMethod => {
    const { userType, schoolCode } = this.props;
    const { redirectUrl, service } = loginMethod;

    if (!_.isEmpty(redirectUrl)) {
      let url = redirectUrl;

      if (service === "PIPS") {
        // set usertype in state
        url = `${url}&state=${encodeURIComponent(
          JSON.stringify({
            usertype: userType,
            school: schoolCode,
          })
        )}`;
      }

      window.location.replace(url);
    }
  };

  getLoginButtonIcon = loginMethod => {
    const { service, logoUrl } = loginMethod;

    if (logoUrl) {
      return (
        <div>
          <div className={classes.loginButtonLogoContainer}>
            <div
              className={classes.loginButtonLogo}
              style={{
                backgroundImage: `url(${logoUrl})`,
              }}
            />
          </div>
        </div>
      );
    }

    switch (service) {
      case "CLEVER":
        return <CleverColored size="x-small" />;
      case "LEX":
        return <LexColored size="x-small" />;
      default:
        return <SquareFilled size="x-small" />;
    }
  };

  // to check if login by specific options like, email otp, password, sms login etc, is enabled
  checkIsLoginByOptionEnabled = option => {
    const {
      isChina,
      loginMethods,
      userType,
      role,
      isOrgWorkspaceLoginPage,
      enablePasswordLoginOption,
    } = this.props;

    const isVisitor = role === "visitor";

    if (
      LOGIN_OPTION_TYPES.PASSWORD_LOGIN === option &&
      !enablePasswordLoginOption
    ) {
      return false;
    }

    // disable sms otp login for china region
    if (LOGIN_OPTION_TYPES.SMS_OTP_LOGIN === option && isChina) {
      return false;
    }

    if (!isOrgWorkspaceLoginPage || isVisitor) {
      return true;
    }

    const idp = _.find(
      loginMethods,
      method =>
        method.type === option &&
        _.includes(method.userTypes, role === "visitor" ? role : userType)
    );

    return !_.isNil(idp);
  };

  renderLoginButton = loginMethod => {
    const { userType, isChina, schoolCode, role } = this.props;
    const {
      service,
      userTypes: allowedUserTypes,
      type,
      id,
      redirectUrl,
      isOrgSpecificMethod = false,
    } = loginMethod;

    if (!_.includes(allowedUserTypes, role === "visitor" ? role : userType)) {
      return null;
    }

    switch (type) {
      case LOGIN_OPTION_TYPES.IDP_CONFIG: {
        const onIdpClick = () => {
          const url = getSamlBackendRedirectUrl({
            idpId: id,
            userType: userType,
            schoolCode,
          });

          //redirect to backend
          window.location.replace(url);
        };

        const buttonText = service === "IBM" ? service : _.capitalize(service);

        return (
          <CustomLoginButton
            key={`${service}_LOGIN_BTN`}
            data-test-id={`button-login-${service}`}
            icon={this.getLoginButtonIcon(loginMethod)}
            buttonText={buttonText}
            onClick={onIdpClick}
          />
        );
      }

      case LOGIN_OPTION_TYPES.OAUTH_IDP_CRED: {
        const onIdpClick = () => {
          this.onOauthIdpSignInClick(loginMethod);
        };

        return (
          <CustomLoginButton
            key={`${service}_LOGIN_BTN`}
            data-test-id={`button-login-${service}`}
            icon={this.getLoginButtonIcon(loginMethod)}
            buttonText={_.capitalize(service)}
            onClick={onIdpClick}
          />
        );
      }

      case LOGIN_OPTION_TYPES.SSO: {
        switch (service) {
          case "GOOGLEV2": {
            return !isChina ? (
              <GoogleLoginBtn
                key={"GOOGLE_LOGIN_BTN"}
                clientId={GOOGLE_CLIENT_ID}
                onSuccess={this.onGoogleSignInCallBack}
                onFailure={this.onGoogelFailureCallBack}
                prompt="select_account"
                innerConStyle={styles.innerConStyle}
                containerStyle={styles.containerStyle}
              />
            ) : null;
          }

          case "MICROSOFT": {
            return (
              <MicrosoftLoginBtn
                key={"MICROSOFT_LOGIN_BTN"}
                onSuccess={this.onMicroSoftSignInCallBack}
                onFailure={this.onMicroSoftFailureCallBack}
                className={classes.buttonContainer}
                innerConStyle={styles.innerConStyle}
                containerStyle={styles.containerStyle}
              />
            );
          }

          case "CLEVER": {
            const isCleverEnabled = userType !== "parent";

            return isCleverEnabled ? (
              <CustomLoginButton
                key={"CLEVER_LOGIN_BTN"}
                data-test-id={"button-login-clever"}
                icon={this.getLoginButtonIcon(loginMethod)}
                onClick={this.onCleverLogInClick}
                buttonText={_.capitalize(service)}
                innerConStyle={styles.innerConStyle}
                containerStyle={styles.containerStyle}
              />
            ) : null;
          }

          case "LEX": {
            return !isChina ? (
              <CustomLoginButton
                key={"LEX_LOGIN_BTN"}
                data-test-id={"button-login-clever"}
                icon={this.getLoginButtonIcon(loginMethod)}
                onClick={this.onLexLoginClick}
                buttonText={_.capitalize(service)}
                innerConStyle={styles.innerConStyle}
                containerStyle={styles.containerStyle}
                isSplitButton={true}
                overlay={
                  <DropdownMenu
                    options={this.getLexOptions()}
                    onClick={this.onClickLexOption}
                  />
                }
              />
            ) : null;
          }

          default: {
            const onClick = () => {
              if (["BLACKBAUD", "VERACROSS"].includes(service)) {
                this.updateToddleInitiatedValue(true);
              }
              window.location.replace(redirectUrl);
            };

            return isOrgSpecificMethod ? (
              <CustomLoginButton
                key={`${service}_LOGIN_BTN`}
                data-test-id={`button-login-${service}`}
                icon={this.getLoginButtonIcon(loginMethod)}
                buttonText={_.capitalize(service)}
                onClick={onClick}
              />
            ) : null;
          }
        }
      }

      default:
        return null;
    }
  };

  renderLoginMethods = () => {
    const { loginMethods, userType } = this.props;
    const isParent = userType === "parent";

    const loginButtons = _.filter(
      _.map(loginMethods, loginMethod => this.renderLoginButton(loginMethod)),
      loginButton => !_.isNil(loginButton)
    );

    const isLoginWithPhoneDisabled = !this.checkIsLoginByOptionEnabled(
      LOGIN_OPTION_TYPES.SMS_OTP_LOGIN
    );

    const isPasswordLoginEnabled = this.checkIsLoginByOptionEnabled(
      LOGIN_OPTION_TYPES.PASSWORD_LOGIN
    );

    const isOTPLoginEnabled = this.checkIsLoginByOptionEnabled(
      LOGIN_OPTION_TYPES.EMAIL_OTP_LOGIN
    );

    if (
      isOTPLoginEnabled ||
      isPasswordLoginEnabled ||
      (isParent && !isLoginWithPhoneDisabled)
    ) {
      loginButtons.unshift(
        <CustomLoginButton
          key={"EMAIL_LOGIN_BTN"}
          data-test-id={"button-login-email"}
          icon={<MailColored size="x-small" />}
          onClick={this.onLoginClick}
          buttonText={
            isParent
              ? !isLoginWithPhoneDisabled &&
                (isOTPLoginEnabled || isPasswordLoginEnabled)
                ? "Email/Phone number"
                : isLoginWithPhoneDisabled
                ? "Email"
                : "Phone number"
              : "Email"
          }
        />
      );
    }

    this.setState({ loginButtonsCount: loginButtons.length });

    return (
      <div>
        <GridLayoutWrapper
          noOfColumns={2}
          itemsPerRow={2}
          stretchItemsInLastRow={false}
        >
          {loginButtons}
        </GridLayoutWrapper>

        <ThirdPartyAuth
          serviceType="CLEVER"
          ref={this.updateCleverAuthRef}
          onSuccessCallBack={this.onCleverSignInCallBack}
        />
        <ThirdPartyAuth
          serviceType="LEX"
          ref={this.updateLexAuthRef}
          onSuccessCallBack={this.onLexSignInCallBack}
        />

        <ThirdPartyAuth
          serviceType="LEX_PILOT"
          ref={this.updateLexPilotAuthRef}
          onSuccessCallBack={this.onLexPilotSignInCallBack}
        />
      </div>
    );
  };

  renderGoToToddleHomeButton = () => {
    const { goToRootPath, resetOrgWorkSpaceDetails } = this.props;

    const handleClick = () => {
      resetOrgWorkSpaceDetails();
      goToRootPath();
    };

    return (
      <Button
        type="outlined"
        variant="outlined-subtle"
        size="medium"
        onClick={handleClick}
      >
        {"Not your school? Go back"}
      </Button>
    );
  };

  renderBackButtonComponent = ({
    onClick,
    style = {},
    buttonText = "Back",
    currentStep,
    maxStep,
    ariaLabel = "Go back to previous screen",
  } = {}) => {
    const {
      enableNewLoginFlow: isNewLoginFlowEnabled,
      currentScreen,
    } = this.props;

    const backButtonContainerStyles = classNames({
      [classes.backBtnContainer]: true,
      [classes.backBtnContainerV2]: isNewLoginFlowEnabled,
    });

    return (
      <div className={backButtonContainerStyles} style={style}>
        {isNewLoginFlowEnabled ? (
          <Button
            onClick={onClick}
            variant={"inline"}
            icon={
              currentScreen === "schoolCodeForm" ? (
                <ChevronLeftOutlined size={"xxx-small"} />
              ) : (
                <LeftArrowCircleOutlined size={"xxx-small"} />
              )
            }
            ref={this.backButtonRef}
            aria-label={ariaLabel}
          >
            {buttonText}
          </Button>
        ) : (
          <div
            className={classes.backBtnInnerContainer}
            onClick={onClick}
            ref={this.backButtonRef}
            role="button"
            tabIndex={0}
            onKeyDown={e =>
              onEnterOrSpaceKeyDown(e, () => onClick && onClick(e))
            }
            aria-label={ariaLabel}
          >
            <ChevronIcon width={6} height={11} fill={colors.neutral200} />
            <div className={classes.backBtnText}>{buttonText}</div>
          </div>
        )}
        {currentStep && maxStep ? (
          <div
            className={classes.stepContainer}
          >{`Step ${currentStep} of ${maxStep}`}</div>
        ) : null}
      </div>
    );
  };

  isPrivacyTextVisible = () => {
    const { currentScreen, userType } = this.props;
    const privacyTextVisibleScreens = [
      "loginHome",
      "teacherLogin",
      "studentLogin",
      "parentLogin",
      "visitorLogin",
      "schoolCodeForm",
      "createParentAccount",
      "verifyParentInviteCode",
      "forgotPassword",
      "loginForm",
      "loginFormV2",
      "resetPassword",
      "loginFormV3",
    ];
    return (
      _.includes(privacyTextVisibleScreens, currentScreen) ||
      userType === "visitor"
    );
  };

  renderCreateAccountPrivacyText = ({
    privacyTextStyle = {},
    buttonText = "",
    isRequesting = false,
  }) => {
    const {
      formData: {
        organizationSelection: {
          selectedSchool: { name: schoolName = "" } = {},
        } = {},
      } = {},
    } = this.props;

    return (
      <div className={classes.privacyText} style={privacyTextStyle}>
        {`${
          buttonText ? `By clicking the “${buttonText}” button,` : ``
        } you are creating a Toddle account ${
          isRequesting && schoolName
            ? `and requesting access from ${schoolName}.`
            : `and`
        } are agreeing to Toddle’s `}
        <span>
          <a
            href={TERM_OF_SERVICE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.underLineButton}
          >
            {`Terms of Service`}
          </a>
        </span>{" "}
        ,
        <span>
          <a
            href={TERM_OF_USE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.underLineButton}
          >
            {`Terms of Use`}
          </a>
        </span>
        {" and "}
        <span>
          <a
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.underLineButton}
          >
            {`Privacy Policy`}
          </a>
        </span>
        .
      </div>
    );
  };

  renderTradeMarkText = (
    { align, containerStyle = {} } = {
      align: "center",
    }
  ) => {
    if (!this.isPrivacyTextVisible()) {
      return null;
    }

    const tradeMarkTextClassname = classNames({
      [classes.tradeMarkTextContainerLeft]: align == "left",
      [classes.tradeMarkTextContainerCenter]: align != "left",
      [classes.tradeMarkContainer]: true,
    });

    const onItemKeyDown = (e, URL) => {
      onEnterOrSpaceKeyDown(e, openLinkInNewTab({ url: URL }));
    };

    return (
      <div className={tradeMarkTextClassname}>
        <div>
          By signing in, you agree to our{" "}
          <span>
            <a
              href={PRIVACY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.underLineButton}
              onKeyDown={e => {
                onItemKeyDown(e, PRIVACY_URL);
              }}
            >
              Privacy Policy
            </a>
          </span>
          ,{" "}
          <span>
            <a
              href={TERM_OF_SERVICE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.underLineButton}
              onKeyDown={e => {
                onItemKeyDown(e, TERM_OF_SERVICE_URL);
              }}
            >
              Terms of Service
            </a>
          </span>
          ,{" "}
          <span>
            <a
              href={TERM_OF_USE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.underLineButton}
              onKeyDown={e => {
                onItemKeyDown(e, TERM_OF_USE_URL);
              }}
            >
              Terms of Use
            </a>
          </span>{" "}
          and{" "}
          <span>
            <a
              href={COOKIE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.underLineButton}
              onKeyDown={e => {
                onItemKeyDown(e, COOKIE_URL);
              }}
            >
              Cookie Policy
            </a>
          </span>
          .
        </div>
      </div>
    );
  };

  UNSAFE_componentWillReceiveProps = nextProps => {
    const nextScreen =
      _.get(nextProps, "location.query.type", "") || "loginHome";
    const userType = _.get(nextProps, "location.query.usertype");

    if (!_.isEqual(nextProps.currentScreen, this.props.currentScreen)) {
      this.scrollRightSideTop();
    }

    if (
      !!nextScreen &&
      !_.isEqual(nextScreen, _.get(this.props, "location.query.type", ""))
    ) {
      this.updateCurrentScreen({ type: nextScreen, userType });
    }
  };

  componentDidUpdate = prevProps => {
    if (!_.isEqual(prevProps.currentScreen, this.props.currentScreen)) {
      this.trackCurrentScreenPage({ currentScreen: this.props.currentScreen });
    }
  };

  scrollRightSideTop = () => {
    if (this.rightSideScrollRef) {
      this.rightSideScrollRef.scrollTop = 0;
    }
  };

  sendResetPassword = (params = {}) => {
    const { userType, sendResetPassword } = this.props;
    sendResetPassword({ ...params, userType });
  };

  sendForgotPassword = (params = {}) => {
    const { userType, sendForgotPassword } = this.props;
    sendForgotPassword({ ...params, userType });
  };

  onGoogelFailureCallBack = e => {
    const errMsg = _.get(e, "error", "");
    if (errMsg == "google_script_not_loaded") {
      this.props.setToastMsg({
        msg: "toastMsgs:something_went_wrong",
        type: "warning",
      });
    } else if (errMsg != "popup_closed_by_user") {
      this.props.setToastMsg({
        msg: "toastMsgs:click_again_to_login",
        type: "warning",
      });
    }

    console.error(e);
  };

  onMicroSoftFailureCallBack = err => {
    /** "ClientAuthError: could not resolve endpoints" occurs when msal
     * is not able to reach the endpoint "https://login.microsoftonline.com". */
    const clientAuthErrorRegex = new RegExp(
      "ClientAuthError: could not resolve endpoints"
    );

    if (_.get(err, "errorCode") === "interaction_in_progress") {
      this.props.setToastMsg({
        msg: "toastMsgs:microsoft_interaction_in_progress",
        type: "warning",
      });
    }

    const errorMessage = _.get(err, "name") + ": " + _.get(err, "errorMessage");
    if (
      _.get(err, "name") &&
      _.get(err, "errorMessage") &&
      !clientAuthErrorRegex.test(errorMessage)
    ) {
      consoleError("ERROR_MIRCROSOFT_LOGIN_PAGE", errorMessage);
    }
  };

  // dynamic custom style to handle 'Go to Toddle Home' button
  getCustomStyle = () => {
    return {
      ...customStyle,
      containerStyle: {
        ...customStyle.containerStyle,
        paddingTop: customStyle.containerStyle.paddingTop,
      },
    };
  };

  renderRightSide = () => {
    const {
      verifyDomain,
      createUnauthenticatedUser,
      createSchoolRequest,
      generateOTPForUnauthenticatedUser,
      generateOTPForParent,
      verifyUnauthenticatedUserOTP,
      verifyParentOTP,
      verifyParentOTPForSignIn,
      createPYPCoordinator,
      createInvitedUser,
      createInvitedParent,
      progressOfUploads,
      isLoading,
      formData: {
        loginForm = {},
        loginFormV2 = {},
        visitorSignup = {},
        parentLoginForm = {},
        forgotPassword = {},
        forgotPhonePassword = {},
        resetPassword = {},
        organizationSelection = {},
        createAccount = {},
        createParentAccount = {},
        verifyParentInviteCode = {},
        addSchool = {},
        verifyOTP = {},
        verifyPhoneOTP = {},
        loginWithPhoneOTP = {},
        addPYPDetails = {},
        requestSuccess = {},
        addIdentification = {},
        requestSuccessCall = {},
        studentLogin = {},
        teacherLogin = {},
        parentLogin = {},
        visitorLogin = {},
        samlLoginForm = {},
        schoolCodeForm = {},
        loginFormV3 = {},
      } = {},
      currentScreen,
      signInUsingCode,
      designationList,
      getDesignationList,
      location,
      userType,
      setCurrentParentLoginTab,
      currentParentLoginTab,
      isFamilyInviteRoute,
      isFamilyClassInviteRoute,
      handleCreateParentAccount,
      handleVerifyParentInviteCode,
      updateInvitedFamilyData,
      setParentInviteCode,
      generateOtpForSignIn,
      parentInviteCode,
      goToBack,
      role,
      isChina,
      enableNewLoginFlow,
      isPwdDisabledInParentSignup,
      generateEmailOTPForSignIn,
      enableSamlLoginFlow,
      enableOrgWorkspaceLoginFlow,
      isOrgWorkspaceLoginPage,
      organizationName,
      workspaceOrgId,
      setAuthRegion,
      enableLoginFlowV2,
      orgLogoUrl,
      invitedFamilyData,
    } = this.props;

    const isChromebookKioskMode = isInKioskMode();

    switch (currentScreen) {
      case "loginHome":
        /** Hide the UI as of now */
        return (
          <LoginHome
            customStyle={this.getCustomStyle()}
            updateCurrentScreen={this.updateCurrentScreen}
            renderRightSideLogo={this.renderRightSideLogo}
            renderTradeMarkText={this.renderTradeMarkText}
            isOrgWorkspaceLoginEnabled={enableOrgWorkspaceLoginFlow}
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
            schoolName={organizationName}
            orgLogoUrl={orgLogoUrl}
          />
        );

      case "teacherLogin":
        return (
          <TeacherLogin
            customStyle={this.getCustomStyle()}
            onGoogleSignInCallBack={this.onGoogleSignInCallBack}
            onGoogelFailureCallBack={this.onGoogelFailureCallBack}
            onMicroSoftFailureCallBack={this.onMicroSoftFailureCallBack}
            onMicroSoftSignInCallBack={this.onMicroSoftSignInCallBack}
            onCleverSignInCallBack={this.onCleverSignInCallBack}
            onLexSignInCallBack={this.onLexSignInCallBack}
            onLexPilotSignInCallBack={this.onLexPilotSignInCallBack}
            updateCurrentScreen={this.updateCurrentScreen}
            renderBackButtonComponent={this.renderBackButtonComponent}
            renderTradeMarkText={this.renderTradeMarkText}
            isCleverEnabled={!isChromebookKioskMode}
            isLexEnabled={!isChina && !isChromebookKioskMode}
            isGoogleEnabled={!isChina}
            isMicrosoftEnabled={true}
            isNewLoginFlowEnabled={enableNewLoginFlow}
            isSamlFlowEnabled={enableSamlLoginFlow}
            data={teacherLogin}
            updateInputField={this.updateInputField}
            checkEmailVerification={this.checkEmailVerification}
            resetScreen={this.resetScreen}
            generateEmailOTPForSignIn={generateEmailOTPForSignIn}
            userType={userType}
            isCreateAccountEnabled={false}
            isOrgWorkspaceLoginEnabled={
              enableOrgWorkspaceLoginFlow && !isChromebookKioskMode
            }
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
            organizationName={organizationName}
            renderLoginMethods={this.renderLoginMethods}
            loginButtonsCount={this.state.loginButtonsCount}
            isOTPLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.EMAIL_OTP_LOGIN
            )}
            isPasswordLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.PASSWORD_LOGIN
            )}
            updateToddleInitiatedValue={this.updateToddleInitiatedValue}
            enableLoginFlowV2={enableLoginFlowV2}
          />
        );
      case "studentLogin":
        return (
          <StudentLogin
            customStyle={this.getCustomStyle()}
            inputStyle={inputStyle}
            onGoogleSignInCallBack={this.onGoogleSignInCallBack}
            onGoogelFailureCallBack={this.onGoogelFailureCallBack}
            onMicroSoftFailureCallBack={this.onMicroSoftFailureCallBack}
            onMicroSoftSignInCallBack={this.onMicroSoftSignInCallBack}
            onCleverSignInCallBack={this.onCleverSignInCallBack}
            onLexSignInCallBack={this.onLexSignInCallBack}
            onLexPilotSignInCallBack={this.onLexPilotSignInCallBack}
            data={studentLogin}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            renderTradeMarkText={this.renderTradeMarkText}
            renderBackButtonComponent={this.renderBackButtonComponent}
            signInUsingCode={signInUsingCode}
            currentScreen={currentScreen}
            isCleverEnabled={!isChromebookKioskMode}
            isLexEnabled={!isChina && !isChromebookKioskMode}
            isGoogleEnabled={!isChina}
            isMicrosoftEnabled={true}
            isNewLoginFlowEnabled={enableNewLoginFlow}
            generateEmailOTPForSignIn={generateEmailOTPForSignIn}
            isSamlFlowEnabled={enableSamlLoginFlow}
            isOrgWorkspaceLoginEnabled={
              enableOrgWorkspaceLoginFlow && !isChromebookKioskMode
            }
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
            organizationName={organizationName}
            renderLoginMethods={this.renderLoginMethods}
            loginButtonsCount={this.state.loginButtonsCount}
            isStudentSigninCodeLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.STUDENT_SIGNIN_CODE
            )}
            workspaceOrgId={workspaceOrgId}
            updateToddleInitiatedValue={this.updateToddleInitiatedValue}
            enableLoginFlowV2={enableLoginFlowV2}
            isOTPLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.EMAIL_OTP_LOGIN
            )}
            isPasswordLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.PASSWORD_LOGIN
            )}
          />
        );
      case "parentLogin":
        return (
          <ParentLogin
            customStyle={this.getCustomStyle()}
            data={parentLogin}
            onGoogleSignInCallBack={this.onGoogleSignInCallBack}
            onGoogelFailureCallBack={this.onGoogelFailureCallBack}
            onMicroSoftFailureCallBack={this.onMicroSoftFailureCallBack}
            onMicroSoftSignInCallBack={this.onMicroSoftSignInCallBack}
            onLexSignInCallBack={this.onLexSignInCallBack}
            onLexPilotSignInCallBack={this.onLexPilotSignInCallBack}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            renderTradeMarkText={this.renderTradeMarkText}
            renderBackButtonComponent={this.renderBackButtonComponent}
            signInUsingCode={signInUsingCode}
            isFamilyClassInviteRoute={isFamilyClassInviteRoute}
            isFamilyInviteRoute={isFamilyInviteRoute}
            isLexEnabled={!isChina && !isChromebookKioskMode}
            isGoogleEnabled={!isChina}
            isMicrosoftEnabled={true}
            isNewLoginFlowEnabled={enableNewLoginFlow}
            renderErrorComponent={this.renderErrorComponent}
            showErrorToast={this.showErrorToast}
            checkEmailVerification={this.checkEmailVerification}
            userType={userType}
            generateEmailOTPForSignIn={generateEmailOTPForSignIn}
            generateOtpForSignIn={generateOtpForSignIn}
            resetScreen={this.resetScreen}
            isSamlFlowEnabled={enableSamlLoginFlow}
            isLoginWithPhoneDisabled={
              !this.checkIsLoginByOptionEnabled(
                LOGIN_OPTION_TYPES.SMS_OTP_LOGIN
              )
            }
            isOrgWorkspaceLoginEnabled={
              enableOrgWorkspaceLoginFlow && !isChromebookKioskMode
            }
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
            organizationName={organizationName}
            renderLoginMethods={this.renderLoginMethods}
            loginButtonsCount={this.state.loginButtonsCount}
            isOTPLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.EMAIL_OTP_LOGIN
            )}
            isPasswordLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.PASSWORD_LOGIN
            )}
            setAuthRegion={setAuthRegion}
            updateToddleInitiatedValue={this.updateToddleInitiatedValue}
            enableLoginFlowV2={enableLoginFlowV2}
            isCreateParentAccountEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.CREATE_PARENT_ACCOUNT
            )}
          />
        );
      case "schoolCodeForm":
        return (
          <SchoolCodeForm
            customStyle={customStyle}
            inputStyle={inputStyle}
            data={schoolCodeForm}
            onGoToSchoolWorkspaceClick={this.onGoToSchoolWorkspaceClick}
            updateCurrentScreen={this.updateCurrentScreen}
            updateInputField={this.updateInputField}
            renderBackButtonComponent={this.renderBackButtonComponent}
            renderTradeMarkText={this.renderTradeMarkText}
            userType={userType}
            role={role}
            backButtonRef={this.backButtonRef}
          />
        );
      case "samlLoginForm":
        return (
          <SamlLogin
            customStyle={customStyle}
            inputStyle={inputStyle}
            data={samlLoginForm}
            onSamlSignInClick={this.onSamlSignInClick}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            checkEmailVerification={this.checkEmailVerification}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            showErrorToast={this.showErrorToast}
            userType={userType}
          />
        );
      case "verifyParentInviteCode":
        return (
          <VerifyParentInviteCode
            customStyle={this.getCustomStyle()}
            renderBackButtonComponent={this.renderBackButtonComponent}
            updateCurrentScreen={this.updateCurrentScreen}
            updateInputField={this.updateInputField}
            data={verifyParentInviteCode}
            showErrorToast={this.showErrorToast}
            handleVerifyParentInviteCode={handleVerifyParentInviteCode}
            setParentInviteCode={setParentInviteCode}
            parentInviteCode={parentInviteCode}
            backButtonRef={this.backButtonRef}
            renderTradeMarkText={this.renderTradeMarkText}
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
            isCreateParentAccountEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.CREATE_PARENT_ACCOUNT
            )}
          />
        );
      case "createParentAccount":
        return (
          <CreateParentAccount
            customStyle={this.getCustomStyle()}
            renderBackButtonComponent={this.renderBackButtonComponent}
            updateCurrentScreen={this.updateCurrentScreen}
            updateInputField={this.updateInputField}
            data={createParentAccount}
            inputStyle={inputStyle}
            renderErrorComponent={this.renderErrorComponent}
            showErrorToast={this.showErrorToast}
            checkEmailVerification={this.checkEmailVerification}
            handleCreateParentAccount={handleCreateParentAccount}
            createInvitedParent={createInvitedParent}
            isFamilyClassInviteRoute={isFamilyClassInviteRoute}
            isFamilyInviteRoute={isFamilyInviteRoute}
            updateInvitedFamilyData={updateInvitedFamilyData}
            invitedFamilyData={invitedFamilyData}
            isPwdDisabledInParentSignup={isPwdDisabledInParentSignup}
            backButtonRef={this.backButtonRef}
            renderTradeMarkText={this.renderTradeMarkText}
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
            parentInviteCode={parentInviteCode}
            location={location}
            setAuthRegion={setAuthRegion}
          />
        );
      case "parentLoginForm":
        return (
          <ParentLoginForm
            customStyle={customStyle}
            renderBackButtonComponent={this.renderBackButtonComponent}
            updateCurrentScreen={this.updateCurrentScreen}
            onSignInClick={this.onSignInClick}
            onPhoneSignInClick={this.onPhoneSignInClick}
            showErrorToast={this.showErrorToast}
            updateInputField={this.updateInputField}
            data={parentLoginForm}
            generateOtpForSignIn={generateOtpForSignIn}
            inputStyle={inputStyle}
            checkEmailVerification={this.checkEmailVerification}
            renderErrorComponent={this.renderErrorComponent}
            setCurrentParentLoginTab={setCurrentParentLoginTab}
            currentParentLoginTab={currentParentLoginTab}
          />
        );
      case "organizationSelection":
        return (
          <OrganizationSelection
            customStyle={customStyle}
            data={organizationSelection}
            onNextClick={this.onNextClick}
            inputStyle={inputStyle}
            renderBackButtonComponent={this.renderBackButtonComponent}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            renderErrorComponent={this.renderErrorComponent}
            resetScreen={this.resetScreen}
            goToScrollTopOffset={this.goToScrollTopOffset}
            showErrorToast={this.showErrorToast}
          />
        );
      case "loginForm": {
        return (
          <LoginForm
            customStyle={this.getCustomStyle()}
            inputStyle={inputStyle}
            onNextClick={this.onNextClick}
            data={loginForm}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            resetScreen={this.resetScreen}
            onSignInClick={this.onSignInClick}
            checkEmailVerification={this.checkEmailVerification}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            showErrorToast={this.showErrorToast}
            userType={userType}
            role={role}
            renderTradeMarkText={this.renderTradeMarkText}
            isNewLoginFlowEnabled={enableNewLoginFlow}
            generateEmailOTPForSignIn={generateEmailOTPForSignIn}
            isOTPLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.EMAIL_OTP_LOGIN
            )}
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
          />
        );
      }
      case "loginFormV2":
        return (
          <LoginFormV2
            customStyle={this.getCustomStyle()}
            data={loginFormV2}
            loginData={this.fetchLoginData()}
            inputStyle={inputStyle}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            resetScreen={this.resetScreen}
            sendForgotPassword={this.sendForgotPassword}
            checkEmailVerification={this.checkEmailVerification}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            showErrorToast={this.showErrorToast}
            userType={userType}
            role={role}
            goToBack={goToBack}
            generateEmailOTPForSignIn={generateEmailOTPForSignIn}
            generateOtpForSignIn={generateOtpForSignIn}
            onSignInWithOTPClick={this.onSignInWithOTPClick}
            verifyParentOTPForSignIn={verifyParentOTPForSignIn}
            isOTPLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.EMAIL_OTP_LOGIN
            )}
            isPasswordLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.PASSWORD_LOGIN
            )}
            renderTradeMarkText={this.renderTradeMarkText}
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
          />
        );

      case "loginFormV3":
        return (
          <LoginFormV3
            role={role}
            data={loginFormV3}
            userType={userType}
            customStyle={this.getCustomStyle()}
            updateInputField={this.updateInputField}
            renderTradeMarkText={this.renderTradeMarkText}
            updateCurrentScreen={this.updateCurrentScreen}
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
            checkEmailVerification={this.checkEmailVerification}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            generateEmailOTPForSignIn={generateEmailOTPForSignIn}
            onSignInWithOTPClick={this.onSignInWithOTPClick}
            onSignInClick={this.onSignInClick}
            generateOtpForSignIn={generateOtpForSignIn}
            verifyParentOTPForSignIn={verifyParentOTPForSignIn}
            showErrorToast={this.showErrorToast}
            isLoginWithPhoneEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.SMS_OTP_LOGIN
            )}
            isOTPLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.EMAIL_OTP_LOGIN
            )}
            isPasswordLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.PASSWORD_LOGIN
            )}
          />
        );
      case "forgotPassword":
        return (
          <ForgotPassword
            customStyle={this.getCustomStyle()}
            data={forgotPassword}
            loginData={this.fetchLoginData()}
            inputStyle={inputStyle}
            updateInputField={this.updateInputField}
            resetScreen={this.resetScreen}
            sendForgotPassword={this.sendForgotPassword}
            checkEmailVerification={this.checkEmailVerification}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            showErrorToast={this.showErrorToast}
            userType={userType}
            goToBack={goToBack}
            renderTradeMarkText={this.renderTradeMarkText}
            backButtonRef={this.backButtonRef}
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
          />
        );
      case "forgotPhonePassword":
        return (
          <ForgotPhonePassword
            renderBackButtonComponent={this.renderBackButtonComponent}
            updateCurrentScreen={this.updateCurrentScreen}
            customStyle={customStyle}
            data={forgotPhonePassword}
            updateInputField={this.updateInputField}
            inputStyle={inputStyle}
            renderErrorComponent={this.renderErrorComponent}
            showErrorToast={this.showErrorToast}
            generateOTPForParent={generateOTPForParent}
          />
        );
      case "loginWithPhoneOTP":
        return (
          <LoginWithPhoneOTP
            generateOtpForSignIn={generateOtpForSignIn}
            customStyle={customStyle}
            renderBackButtonComponent={this.renderBackButtonComponent}
            data={loginWithPhoneOTP}
            updateCurrentScreen={this.updateCurrentScreen}
            updateInputField={this.updateInputField}
            isLoading={isLoading}
            renderCreateAccountPrivacyText={this.renderCreateAccountPrivacyText}
            verifyParentOTPForSignIn={verifyParentOTPForSignIn}
          ></LoginWithPhoneOTP>
        );
      case "resetPassword":
        return (
          <ResetPassword
            customStyle={customStyle}
            data={resetPassword}
            inputStyle={inputStyle}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            resetScreen={this.resetScreen}
            sendResetPassword={this.sendResetPassword}
            renderErrorComponent={this.renderErrorComponent}
            showErrorToast={this.showErrorToast}
            renderTradeMarkText={this.renderTradeMarkText}
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
          />
        );

      case "createAccount":
        return (
          <CreateAccount
            customStyle={customStyle}
            getDesignationList={getDesignationList}
            data={createAccount}
            onNextClick={this.onNextClick}
            designationList={designationList}
            organizationSelectionData={organizationSelection}
            inputStyle={inputStyle}
            checkEmailVerification={this.checkEmailVerification}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            resetScreen={this.resetScreen}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            verifyDomain={verifyDomain}
            createUnauthenticatedUser={createUnauthenticatedUser}
            renderCreateAccountPrivacyText={this.renderCreateAccountPrivacyText}
            createInvitedUser={createInvitedUser}
            renderContactUsButton={this.renderContactUsButton}
            showErrorToast={this.showErrorToast}
          />
        );

      case "visitorSignup": {
        return (
          <VisitorSignUp
            updateInputField={this.updateInputField}
            checkEmailVerification={this.checkEmailVerification}
            renderErrorComponent={this.renderErrorComponent}
            updateCurrentScreen={this.updateCurrentScreen}
            data={{ ...visitorSignup }}
            customStyle={customStyle}
            sendResetPassword={this.sendResetPassword}
            showErrorToast={this.showErrorToast}
            renderTradeMarkText={this.renderTradeMarkText}
            setVisitorLoginForm={this.props.updateInputField}
          />
        );
      }

      case "visitorLogin": {
        return (
          <VisitorLogin
            renderBackButtonComponent={this.renderBackButtonComponent}
            updateCurrentScreen={this.updateCurrentScreen}
            onGoogleSignInCallBack={this.onGoogleSignInCallBack}
            onGoogelFailureCallBack={this.onGoogelFailureCallBack}
            onMicroSoftSignInCallBack={this.onMicroSoftSignInCallBack}
            onMicroSoftFailureCallBack={() => {
              console.error("error");
            }}
            isNewLoginFlowEnabled={enableNewLoginFlow}
            data={visitorLogin}
            updateInputField={this.updateInputField}
            checkEmailVerification={this.checkEmailVerification}
            resetScreen={this.resetScreen}
            generateEmailOTPForSignIn={generateEmailOTPForSignIn}
            userType={userType}
            customStyle={this.getCustomStyle()}
            role={role}
            isOrgWorkspaceLoginPage={isOrgWorkspaceLoginPage}
            loginButtonsCount={this.state.loginButtonsCount}
            renderTradeMarkText={this.renderTradeMarkText}
            organizationName={organizationName}
            enableLoginFlowV2={enableLoginFlowV2}
            isOTPLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.EMAIL_OTP_LOGIN
            )}
            isPasswordLoginEnabled={this.checkIsLoginByOptionEnabled(
              LOGIN_OPTION_TYPES.PASSWORD_LOGIN
            )}
          />
        );
      }

      case "addSchool":
        return (
          <AddSchool
            onNextClick={this.onNextClick}
            customStyle={customStyle}
            getDesignationList={getDesignationList}
            data={addSchool}
            designationList={designationList}
            inputStyle={inputStyle}
            checkEmailVerification={this.checkEmailVerification}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            resetScreen={this.resetScreen}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            createSchoolRequest={createSchoolRequest}
            progressOfUploads={progressOfUploads}
            renderContactUsButton={this.renderContactUsButton}
            showErrorToast={this.showErrorToast}
          />
        );

      case "verifyOTP":
        return (
          <VerifyOTP
            isLoading={isLoading}
            customStyle={this.getCustomStyle()}
            data={verifyOTP}
            inputStyle={inputStyle}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            resetScreen={this.resetScreen}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            generateOTPForUnauthenticatedUser={
              generateOTPForUnauthenticatedUser
            }
            verifyUnauthenticatedUserOTP={verifyUnauthenticatedUserOTP}
            verifyParentOTP={verifyParentOTP}
            renderCreateAccountPrivacyText={this.renderCreateAccountPrivacyText}
            userType={userType}
            generateOTPForParent={generateOTPForParent}
          />
        );
      case "verifyPhoneOTP":
        return (
          <VerifyPhoneOTP
            generateOTPForParent={generateOTPForParent}
            customStyle={customStyle}
            renderBackButtonComponent={this.renderBackButtonComponent}
            data={verifyPhoneOTP}
            updateCurrentScreen={this.updateCurrentScreen}
            updateInputField={this.updateInputField}
            isLoading={isLoading}
            renderCreateAccountPrivacyText={this.renderCreateAccountPrivacyText}
            verifyParentOTP={verifyParentOTP}
          />
        );
      case "addPYPDetails":
        return (
          <AddPYPDetails
            customStyle={customStyle}
            data={addPYPDetails}
            inputStyle={inputStyle}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            resetScreen={this.resetScreen}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            createPYPCoordinator={createPYPCoordinator}
            checkEmailVerification={this.checkEmailVerification}
            showErrorToast={this.showErrorToast}
          />
        );

      case "requestSuccess":
        return (
          <RequestSuccess
            data={requestSuccess}
            customStyle={customStyle}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
          />
        );

      case "addIdentification":
        return (
          <AddIdentification
            data={addIdentification}
            customStyle={customStyle}
            inputStyle={inputStyle}
            updateInputField={this.updateInputField}
            updateCurrentScreen={this.updateCurrentScreen}
            renderErrorComponent={this.renderErrorComponent}
            renderBackButtonComponent={this.renderBackButtonComponent}
            progressOfUploads={progressOfUploads}
            renderContactUsButton={this.renderContactUsButton}
            showErrorToast={this.showErrorToast}
          />
        );
    }
    return null;
  };

  updateRightSideScrollRef = ref => {
    this.rightSideScrollRef = ref;
  };

  goToScrollTopOffset = ({ element }) => {
    if (this.rightSideScrollRef) {
      if (element && !isIphone()) {
        this.rightSideScrollRef.scrollTop = _.get(element, "offsetTop", 0) - 32;
      }
    }
  };

  showErrorToast = ({ errorCount }) => {
    if (errorCount <= 0) {
      return;
    }
    const countString = getCountString({
      count: errorCount,
      singularText: "error",
      pluralText: "errors",
      postfix: " ",
      shouldShowZero: true,
    });
    this.props.setToastMsg({
      msg: `toastMsgs:rectify_errors_with_count`,
      locale_params: [{ key: "count", value: errorCount, isPlainText: true }],
      position: "toast-top-center",
      type: "warning",
      fill: colors.yellow500,
    });
  };

  renderLogo = () => {
    const { isOrgWorkspaceLoginPage } = this.props;

    if (isOrgWorkspaceLoginPage) {
      return null;
    }

    // default Toddle logo
    return (
      <div className={classes.defaultLogoContainer}>
        <div className={classes.toddleLogo}>
          <ToddleIcon width={48} height={48} />
        </div>
        <div className={classes.toddleLogoText}>
          <LogoTextSvg scale={1.35} />
        </div>
      </div>
    );
  };

  renderRightSideLogo = () => {
    return (
      <div className={classes.rightsidelogocontainer}>{this.renderLogo()}</div>
    );
  };

  renderContactUsButton = ({
    text = "Chat with us",
    style = { color: colors.blue400 },
  } = {}) => {
    return (
      <span
        className={classes.writeToUsButton}
        onClick={this.onContactusButtonClick}
        onKeyDown={e => onEnterOrSpaceKeyDown(e, this.onContactusButtonClick)}
        role="button"
        tabIndex={0}
        aria-label={typeof text === "string" ? text : "Chat with us"}
        style={style}
      >
        {text}
      </span>
    );
  };

  onContactusButtonClick = () => {
    openChat();
  };

  getLeftBannerUrl = () => {
    const {
      userType,
      currentScreen,
      mainBannerImageUrl,
      teacherPageBannerImageUrl,
      studentPageBannerImageUrl,
      parentPageBannerImageUrl,
      isOrgWorkspaceLoginPage,
    } = this.props;

    const URL = `${getCloudUrl()}/assets/webapp/login_page`;

    const getBannerImageUrl = (imageUrl, defaultUrl) =>
      !_.isEmpty(imageUrl) ? imageUrl : defaultUrl;

    if (isOrgWorkspaceLoginPage) {
      return getBannerImageUrl(
        mainBannerImageUrl,
        `${URL}/schoolLoginPageDefault.svg`
      );
    }

    if (currentScreen === "loginHome") {
      return getBannerImageUrl(mainBannerImageUrl, `${URL}/HomeLeftBanner.svg`);
    }

    const bannerUrls = {
      staff: teacherPageBannerImageUrl,
      student: studentPageBannerImageUrl,
      parent: parentPageBannerImageUrl,
    };

    const defaultBannerUrls = {
      staff: `${URL}/TeacherLeftBanner.svg`,
      student: `${URL}/StudentLeftBanner.svg`,
      parent: `${URL}/FamilyLeftBanner.svg`,
    };

    return getBannerImageUrl(
      bannerUrls[userType] || mainBannerImageUrl,
      defaultBannerUrls[userType] || `${URL}/HomeLeftBanner.svg`
    );
  };

  handleOpenLinkInNewTab = () => {
    const { openLinkInNewTab } = this.props;
    openLinkInNewTab({ url: "https://hubs.li/Q02ZvwL_0" });
  };

  render() {
    const {
      loginError,
      isOrgWorkspaceLoginPage,
      showMfaVerificationModal,
    } = this.props;
    const { showMagicLinkModal } = this.state;

    return (
      <div className={classes.container}>
        <div className={classes.leftSide}>
          <div
            className={classes.leftBanner}
            style={{
              backgroundImage: `url(${this.getLeftBannerUrl()})`,
            }}
          />
          <div className={classes.leftSideLogoContainer}>
            {this.renderLogo()}
          </div>
        </div>

        <div className={classes.rightSide} ref={this.updateRightSideScrollRef}>
          {isOrgWorkspaceLoginPage ? (
            <div className={classes.topBackButton}>
              {this.renderGoToToddleHomeButton()}
            </div>
          ) : null}
          <div className={classes.rightSideInnerContainer}>
            {this.renderRightSide()}
          </div>
        </div>
        {!!loginError && showMagicLinkModal && (
          <MagicLinkExpired
            closeModal={() => this.setState({ showMagicLinkModal: false })}
          />
        )}
        {showMfaVerificationModal ? <VerificationAuthModal /> : null}
      </div>
    );
  }
}

const mapActionCreators = {
  getIdpUrlFromServer,
  authenticateUserWithServer,
  updateInputField,
  updateCurrentScreen,
  sendForgotPassword,
  sendResetPassword,
  verifyDomain,
  createUnauthenticatedUser,
  createSchoolRequest,
  generateOTPForUnauthenticatedUser,
  generateOTPForParent,
  verifyUnauthenticatedUserOTP,
  verifyParentOTP,
  createPYPCoordinator,
  createInvitedUser,
  createInvitedParent,
  getDesignationList,
  setToastMsg,
  setCurrentScreen,
  signInUsingCode,
  updateQueryParameters,
  setBifurcationAction,
  setRedirectUrl,
  setUserComingFromPublicAccess,
  setCurrentParentLoginTab,
  handleCreateParentAccount,
  goToBack,
  handleVerifyParentInviteCode,
  updateInvitedFamilyData,
  generateOtpForSignIn,
  verifyParentOTPForSignIn,
  setParentInviteCode,
  generateEmailOTPForSignIn,
  navigateToOrgWorkspaceLoginPage,
  getLoginConfig,
  goToRootPath,
  resetOrgWorkSpaceDetails,
  loginWithRedirectUrl,
  setAuthRegion,
  openLinkInNewTab,
};

const mapStateToProps = (state, ownProps) => {
  const { isOrgWorkspaceLoginPage } = ownProps;
  const userType = _.get(ownProps, "location.query.usertype", "staff");
  const invitedFamilyData = state.login.invitedFamilyData;
  const orgWorkspaceDetails = getOrgWorkSpaceDetails();
  const organizationId = _.get(orgWorkspaceDetails, "organizationId");
  const organizationName = _.get(orgWorkspaceDetails, "organizationName");
  const loginMethods = _.get(orgWorkspaceDetails, "loginMethods", []);
  const mainBannerImageUrl = _.get(
    orgWorkspaceDetails,
    "mainBannerImageUrl",
    null
  );
  const teacherPageBannerImageUrl = _.get(
    orgWorkspaceDetails,
    "teacherPageBannerImageUrl",
    null
  );
  const studentPageBannerImageUrl = _.get(
    orgWorkspaceDetails,
    "studentPageBannerImageUrl",
    null
  );
  const parentPageBannerImageUrl = _.get(
    orgWorkspaceDetails,
    "parentPageBannerImageUrl",
    null
  );

  const orgLogoUrl = _.get(orgWorkspaceDetails, "logoUrl", null);
  const schoolCode = _.get(orgWorkspaceDetails, "schoolCode", null);
  const showMfaVerificationModal = _.get(
    state,
    "login.mfaVerificationDetails.isVisible",
    false
  );

  return {
    parentInviteCode: _.get(state, "login.parentInviteCode", null),
    designationList: state.login.designationList,
    isLoading: state.login.isLoading,
    currentScreen: state.login.currentScreen,
    userType: _.get(ownProps, "location.query.usertype"),
    formData: state.login.formData,
    progressOfUploads: state.app_services.progressOfUploads,
    loginError: _.get(state, "login.loginError"),
    currentParentLoginTab: _.get(state, "login.currentParentLoginTab", "EMAIL"),
    role: _.get(ownProps, "location.query.role", ""),
    isFamilyClassInviteRoute:
      _.get(invitedFamilyData, "type") === "family_class_invite",
    isFamilyInviteRoute: _.get(invitedFamilyData, "type") === "invite_family",
    isChina: getIsChina(),
    isPwdDisabledInParentSignup: getIsPwdDisabledInParentSignup(),
    enableNewLoginFlow: getIsNewLoginFlowEnabled({ userType }),
    enableSamlLoginFlow: getIsSamlLoginEnabled({ userType }),
    enablePasswordLoginOption: getIsPasswordloginEnabled({ userType }),
    enableLoginFlowV2: getIsLoginFlowEnabledV2({ userType }),
    enableOrgWorkspaceLoginFlow: !!enableOrgWorkspaceLoginFlow,
    orgWorkspaceDetails,
    invitedFamilyData,
    showMfaVerificationModal,
    ...(isOrgWorkspaceLoginPage
      ? {
          workspaceOrgId: organizationId,
          organizationName,
          loginMethods,
          mainBannerImageUrl,
          teacherPageBannerImageUrl,
          studentPageBannerImageUrl,
          parentPageBannerImageUrl,
          orgLogoUrl,
          schoolCode,
        }
      : {}),
  };
};

export default connect(mapStateToProps, mapActionCreators)(LoginPage);
